"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CertificateProcessor = void 0;

var tslib_1 = require("tslib");

var common_1 = require("../../utils/common");

var shared_1 = require("../../shared");

var dayjs_1 = tslib_1.__importDefault(require("dayjs"));

require("dayjs/locale/ru");

var _sortBy = require("lodash/sortBy");

var _uniq = require("lodash/uniq");

var _isEqual = require("lodash/isEqual");

var _memoize = require("lodash/memoize");

var Log_1 = require("@skbkontur/plugin-js/lib/common/Log");

var constants_1 = require("../../utils/constants");

var features_1 = require("../../utils/features");

var CertificateProcessor =
/** @class */
function () {
  function CertificateProcessor(options) {
    var _this = this;

    this.options = options;
    this.log = Log_1.LogManager.getLog(constants_1.LOG_PREFIX + "CertificateProcessor");

    this.checkVisibilityByStatus = function (items) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var _a, _b, visiblePeriodByCAStatus, localTimeShift, customFilter, batchFilterAsync, checkedItems, certificates, filteredThumbprints_1;

        return tslib_1.__generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              _a = this.options, _b = _a.visiblePeriodByCAStatus, visiblePeriodByCAStatus = _b === void 0 ? {} : _b, localTimeShift = _a.localTimeShift, customFilter = _a.customFilter, batchFilterAsync = _a.batchFilterAsync;
              checkedItems = items.map(function (item) {
                var statusInfo = item.statusInfo,
                    certificate = item.certificate;

                if (statusInfo && visiblePeriodByCAStatus[statusInfo.status] !== undefined) {
                  var now = new Date(Date.now() + localTimeShift);
                  var msAfterExpiring = now.getTime() - certificate.validTo().getTime();
                  var daysAfterExpiring = common_1.millisecondsToDays(msAfterExpiring);
                  var caStatusVisiblePeriod = visiblePeriodByCAStatus[statusInfo.status];
                  item.visible = daysAfterExpiring < caStatusVisiblePeriod;
                }

                return item;
              });

              if (customFilter) {
                checkedItems = checkedItems.map(function (item) {
                  item.hiddenByCustomFilter = customFilter(item.certificate, item) !== true;
                  return item;
                });
              }

              if (!batchFilterAsync) return [3
              /*break*/
              , 2];
              certificates = checkedItems.map(function (item) {
                return item.certificate;
              });
              return [4
              /*yield*/
              , batchFilterAsync(certificates)];

            case 1:
              filteredThumbprints_1 = _c.sent().map(function (c) {
                return c.thumbprint();
              });
              checkedItems = checkedItems.map(function (item) {
                item.hiddenByCustomFilter = filteredThumbprints_1.includes(item.certificate.thumbprint()) !== true;
                return item;
              });
              _c.label = 2;

            case 2:
              return [2
              /*return*/
              , checkedItems];
          }
        });
      });
    };

    this.getValidItems = function (items) {
      return items.filter(function (item) {
        return !["InBlacklist"
        /* InBlacklist */
        , "IssuerNotValid"
        /* IssuerNotValid */
        ].includes(item.state);
      });
    };

    this.getVisibleItems = function (items) {
      return _this.getValidItems(items).filter(function (item) {
        return item.visible && item.hiddenByCustomFilter === false;
      });
    };

    this.getAllVisibleItems = function (items) {
      return _this.getValidItems(items).filter(function (item) {
        return item.visible;
      });
    };

    this.getInvalidItems = function (items) {
      return items.filter(function (item) {
        return ["InBlacklist"
        /* InBlacklist */
        , "IssuerNotValid"
        /* IssuerNotValid */
        ].includes(item.state);
      });
    };

    this.getRevokedItems = function (items) {
      return items.filter(function (item) {
        return "InBlacklist"
        /* InBlacklist */
        === item.state;
      });
    };

    this.getInvalidIssuerItems = function (items) {
      return items.filter(function (item) {
        return "IssuerNotValid"
        /* IssuerNotValid */
        === item.state;
      });
    };

    this.getFilteredByClient = function (items) {
      return items.filter(function (item) {
        return item.hiddenByCustomFilter;
      });
    };

    this.getCabucIssersItems = function (items) {
      return items.filter(function (item) {
        return item.fromCabuc;
      });
    };

    this.getActiveItems = function (items) {
      return items.filter(function (item) {
        return item.state === "Active"
        /* Active */
        ;
      });
    };

    this.getExpiringItems = function (items) {
      return items.filter(function (item) {
        return item.state === "Expiring"
        /* Expiring */
        ;
      });
    };

    this.getExpiredItems = function (items) {
      return items.filter(function (item) {
        return item.state === "Expired"
        /* Expired */
        ;
      });
    };

    this.getPeriodByStatus = function (status) {
      var _a = _this.options.visiblePeriodByCAStatus,
          visiblePeriodByCAStatus = _a === void 0 ? {} : _a;
      return visiblePeriodByCAStatus[status] || 0;
    };
    /**
     * Получаем дополнительную информцию по сертификатам.
     * Состояние state: CertificateStatusCode
     * Видимость visible: boolean
     * Строку предупреждение об окончании действия
     * Строку информации об окончании действия
     * Наличие "дубликатов" вычисляется позднее.
     * @param certificateInfos: ICertificateInfo[]
     * @return ICertificateListItem[]
     */


    this.process = function (certificateInfos) {
      return tslib_1.__awaiter(_this, void 0, void 0, function () {
        var _a, localTimeShift, _b, cabucIssuers, customFilter, batchFilterAsync, timeWhenCertificateWasFound, items, certificates, filteredThumbprints_2;

        var _this = this;

        return tslib_1.__generator(this, function (_c) {
          switch (_c.label) {
            case 0:
              _a = this.options, localTimeShift = _a.localTimeShift, _b = _a.cabucIssuers, cabucIssuers = _b === void 0 ? [] : _b, customFilter = _a.customFilter, batchFilterAsync = _a.batchFilterAsync;
              timeWhenCertificateWasFound = new Date(Date.now() + localTimeShift);
              items = certificateInfos.map(function (_a) {
                var certificate = _a.certificate,
                    storeInfo = _a.storeInfo;

                var state = _this.getCertificateState(certificate, timeWhenCertificateWasFound);

                var fromCabuc = cabucIssuers.length ? cabucIssuers.includes(certificate.issuer()) : true; // #emptyCabucIssuers

                var visible = _this.getCertificateVisibility(certificate, state, timeWhenCertificateWasFound, fromCabuc);

                var item = {
                  certificate: certificate,
                  storeInfo: storeInfo,
                  state: state,
                  visible: visible,
                  hasDublicate: false,
                  fromCabuc: fromCabuc,
                  hiddenByCustomFilter: false,
                  timeWhenCertificateWasFound: timeWhenCertificateWasFound
                };
                return item;
              });

              if (customFilter) {
                items = items.map(function (item) {
                  item.hiddenByCustomFilter = customFilter(item.certificate, item) !== true;
                  return item;
                });
              }

              if (!batchFilterAsync) return [3
              /*break*/
              , 2];
              certificates = items.map(function (item) {
                return item.certificate;
              });
              return [4
              /*yield*/
              , batchFilterAsync(certificates)];

            case 1:
              filteredThumbprints_2 = _c.sent().map(function (c) {
                return c.thumbprint();
              });
              items = items.map(function (item) {
                item.hiddenByCustomFilter = filteredThumbprints_2.includes(item.certificate.thumbprint()) !== true;
                return item;
              });
              _c.label = 2;

            case 2:
              return [2
              /*return*/
              , items];
          }
        });
      });
    };
    /**
     * У сертификата может быть одинаковые значения для полей: organizationName, owner и inn.
     * Но при этом разные даты срока действия. Такие сертификаты отмечаются как имеющие дубликат.
     */


    this.checkForDublicates = function (items) {
      var dublicatesThumbprints = [];
      var thumbprintByUniqKey = {};
      items.forEach(function (item) {
        var certificate = item.certificate;
        var uniqKey = certificate.owner().toLowerCase() + certificate.inn();
        var existingThumbprint = thumbprintByUniqKey[uniqKey];

        if (existingThumbprint) {
          dublicatesThumbprints.push(existingThumbprint);
          dublicatesThumbprints.push(certificate.thumbprint());
        } else {
          thumbprintByUniqKey[uniqKey] = certificate.thumbprint();
        }
      });
      dublicatesThumbprints = _uniq(dublicatesThumbprints);
      return items.map(function (item) {
        if (dublicatesThumbprints.includes(item.certificate.thumbprint())) {
          item.hasDublicate = true;

          _this.log.info('This certificate has dublicate in list', item.certificate);
        }

        return item;
      });
    };

    this.sortCertificates = function (items) {
      if (_this.options.saveDefaultCertOrder) {
        return items;
      }

      var expiring = _this.getExpiringItems(items);

      expiring = expiring.sort(function (item1, item2) {
        return item1.certificate.validTo().getTime() - item2.certificate.validTo().getTime();
      });

      var active = _this.getActiveItems(items);

      active = active.sort(function (item1, item2) {
        return item1.certificate.validTo().getTime() - item2.certificate.validTo().getTime();
      });

      var expired = _this.getExpiredItems(items);

      expired = expired.sort(function (item1, item2) {
        return item2.certificate.validTo().getTime() - item1.certificate.validTo().getTime();
      });
      var blacklisted = items.filter(function (item) {
        return item.state === "InBlacklist"
        /* InBlacklist */
        ;
      });
      var sorted = expiring.concat(active, expired, blacklisted);
      var _a = _this.options,
          customSort = _a.customSort,
          _b = _a.sortByStatus,
          sortByStatus = _b === void 0 ? false : _b;

      if (customSort) {
        sorted = _sortBy(sorted, function (item) {
          return customSort(item.certificate, item);
        });
      }

      if (sortByStatus) {
        sorted = _this.sortByStatus(sorted);
      }

      if (features_1.getFeatureList()['MoveReissuingCertsUp']) {
        sorted = _this.moveReissuingCertsUp(sorted);
      }

      return sorted;
    };
    /**
     * Сортировка по статусам, auth-960.
     * Если для сертификата с1 вернулся статус 8 - сертификат установлен, то значит
     * в списке должен быть новый дубликат сертификата с2.
     *
     * Проблема: Заходить пользователю теперь надо по с2, но с1 расположен в списке выше чем с2.
     * По с1 пользователь сможет заходить пока с1 не отзовут, либо он не истечет и тогда он будет скрыт.
     * Причины:
     * - по с1 недавно заходили и сортировка customSort расположит его выше.
     * - c1 может быть в состоянии expiring что тоже помещает его выше чем c2, который точно active.
     * Решение:
     * Для того чтобы выполнить сортировку списка нужно чтобы выполнилось условие:
     * В списке есть сертификат с1 со статусом 8, и в его statusInfo заполнен NewThumbprint - отпечаток с2,
     * и с2 есть в списке.
     * Далее
     * 1. Eсли с2 расположен ниже чем с1, то перемещаем с2 на место с1, а с1 сдвигаем в конец списка.
     * 2. Если с2 расположен выше чем с1, то с1 сдвигаем в конец списка.
     * Эту операцию нужно выполнить для всех сертификатов со статусом 8, для которых выполняется условие.
     *
     * @param items: ICertificateListItem[]
     * @return ICertificateListItem[]
     */


    this.sortByStatus = function (items) {
      var sorted = [];
      var installedCerts = [];
      var thumbrpints = items.map(function (item) {
        return item.certificate.thumbprint();
      });
      var movedThumbprints = [];
      items.forEach(function (item, index) {
        if (movedThumbprints.includes(item.certificate.thumbprint())) {
          // если сертификат с этим отпечатком уже переместили, то пропускаем его.
          return;
        } // пропускаем не подходящие сертификаты


        var skipCert = !item.statusInfo || item.statusInfo.status !== shared_1.CabucStatusCode.Installed || !item.statusInfo.newThumbprint;

        if (skipCert) {
          sorted.push(item);
          return;
        }

        var newCertThumbprint = item.statusInfo.newThumbprint; // !

        var newCertIndex = thumbrpints.indexOf(newCertThumbprint);

        if (newCertIndex === -1) {
          // нового сертификата нет в списке - ничего сортировать не надо.
          sorted.push(item);
          return;
        }

        if (movedThumbprints.includes(newCertThumbprint)) {
          // если сертификат с этим отпечатком уже переместили, то пропускаем его.
          return;
        }

        var oldCertIndex = thumbrpints.indexOf(item.certificate.thumbprint());

        if (newCertIndex > oldCertIndex) {
          // ставим новый на место старого
          sorted.push(items[newCertIndex]); // сохраняем отпечаток сертификата в массиве перемещенных сертификатов.

          movedThumbprints.push(newCertThumbprint);
        } // старый сертификат помещаем в конец.


        installedCerts.push(item);
      });
      sorted = sorted.concat(installedCerts);

      if (items.length !== sorted.length) {
        _this.trackEventOnce('sortedByStatus', 'error');

        return items;
      } else {
        var sortedThumbprints = sorted.map(function (item) {
          return item.certificate.thumbprint();
        });

        if (!_isEqual(thumbrpints, sortedThumbprints)) {
          _this.trackEventOnce('sortedByStatus', 'done');
        }

        return sorted;
      }
    };
    /**
     * Перемещаем сертификаты со статусом 171 (действующий сертификат, требующий перевыпуска) вверх списка
     * Сертификаты перемещаются в том же порядке, в котором они находились в списке.
     * https://yt.skbkontur.ru/issue/auth-1759
     */


    this.moveReissuingCertsUp = function (items) {
      var reissuingCerts = [];
      var otherCerts = [];
      var thumbrpintsBeforeSort = items.map(function (item) {
        return item.certificate.thumbprint();
      });
      items.forEach(function (item) {
        if (item.statusInfo && item.statusInfo.status === shared_1.CabucStatusCode.HeraclesReissueActiveCert) {
          reissuingCerts.push(item);
          return;
        }

        otherCerts.push(item);
      });

      var result = tslib_1.__spreadArrays(reissuingCerts, otherCerts);

      var thumbprintsAfterSort = result.map(function (item) {
        return item.certificate.thumbprint();
      });

      if (!_isEqual(thumbrpintsBeforeSort, thumbprintsAfterSort)) {
        var movedThumbprints = reissuingCerts.map(function (item) {
          return item.certificate.thumbprint();
        });

        _this.trackEventOnce('moveReissuingCertsUp', 'done', {
          movedThumbprints: movedThumbprints
        });
      }

      return result;
    };

    this.updateOptions = function (newOptions) {
      _this.options = tslib_1.__assign(tslib_1.__assign({}, _this.options), newOptions);
    };

    this.getCertificateState = function (c, now) {
      var _a = _this.options,
          warnBeforeExpiringPeriod = _a.warnBeforeExpiringPeriod,
          validIssuers = _a.validIssuers,
          blacklist = _a.blacklist;
      var restInMs = c.validTo().getTime() - now.getTime();
      var expiringPeriod = common_1.daysToMilliseconds(warnBeforeExpiringPeriod);
      var state;
      var issuer = c.issuer();

      switch (true) {
        case issuer !== constants_1.TRUSTED_ISSUER && validIssuers.length && !validIssuers.includes(issuer):
          {
            state = "IssuerNotValid"
            /* IssuerNotValid */
            ;
            break;
          }

        case blacklist.includes(c.thumbprint()):
          {
            state = "InBlacklist"
            /* InBlacklist */
            ;
            break;
          }

        case 0 < restInMs && restInMs <= expiringPeriod:
          {
            state = "Expiring"
            /* Expiring */
            ;
            break;
          }

        case restInMs <= 0:
          {
            state = "Expired"
            /* Expired */
            ;
            break;
          }

        default:
          {
            state = "Active"
            /* Active */
            ;
          }
      }

      return state;
    };

    this.getCertificateVisibility = function (certificate, state, now, fromCabuc) {
      var visible;

      switch (true) {
        case ["InBlacklist"
        /* InBlacklist */
        , "IssuerNotValid"
        /* IssuerNotValid */
        ].includes(state):
          {
            visible = false;
            break;
          }

        case ["Active"
        /* Active */
        , "Expiring"
        /* Expiring */
        ].includes(state):
          {
            visible = true;
            break;
          }

        case state === "Expired"
        /* Expired */
        :
          {
            var msAfterExpiring = now.getTime() - certificate.validTo().getTime();
            var daysAfterExpiring = common_1.millisecondsToDays(msAfterExpiring);
            var _a = _this.options,
                showCertAfterExpiringPeriod = _a.showCertAfterExpiringPeriod,
                showNotCabucCertAfterExpiringPeriod = _a.showNotCabucCertAfterExpiringPeriod;
            visible = fromCabuc ? daysAfterExpiring < showCertAfterExpiringPeriod : daysAfterExpiring < showNotCabucCertAfterExpiringPeriod;
            break;
          }

        default:
          {
            visible = true;
          }
      }

      return visible;
    };

    this.trackEventOnce = _memoize(this.options.trackEvent, function (_, action, label) {
      return action + ":" + label;
    });
  }

  CertificateProcessor.prototype.getValidToMessage = function (item, options) {
    if (options === void 0) {
      options = {};
    }

    var _a = this.options,
        localTimeShift = _a.localTimeShift,
        warnBeforeExpiringPeriod = _a.warnBeforeExpiringPeriod;
    var _b = options.capital,
        capital = _b === void 0 ? false : _b,
        _c = options.possessive,
        possessive = _c === void 0 ? true : _c,
        _d = options.declarative,
        declarative = _d === void 0 ? false : _d,
        _e = options.daysCountdown,
        daysCountdown = _e === void 0 ? warnBeforeExpiringPeriod || 30 : _e,
        _f = options.exactExpirationTime,
        exactExpirationTime = _f === void 0 ? 7 : _f,
        _g = options.timeCountdown,
        timeCountdown = _g === void 0 ? 1 : _g;
    var validTo = item.certificate.validTo,
        timeWhenCertificateWasFound = item.timeWhenCertificateWasFound;
    var restInMs = validTo().getTime() - timeWhenCertificateWasFound.getTime() + localTimeShift;
    var exactExpirationTimeInMs = common_1.daysToMilliseconds(exactExpirationTime);
    var dayInMs = common_1.daysToMilliseconds(timeCountdown);
    var daysCountdownInMs = common_1.daysToMilliseconds(daysCountdown);
    var validToString = '';

    switch (true) {
      case !declarative && exactExpirationTimeInMs < restInMs && restInMs <= daysCountdownInMs:
        {
          var days = common_1.millisecondsToDays(restInMs);
          validToString = "\u0437\u0430\u043A\u043E\u043D\u0447\u0438\u0442\u0441\u044F \u0447\u0435\u0440\u0435\u0437 " + days + " " + common_1.getPluralForm(days, ['день', 'дня', 'дней']);
          break;
        }

      case !declarative && dayInMs < restInMs && restInMs <= exactExpirationTimeInMs:
        {
          var date = dayjs_1.default(validTo()).format('D MMMM YYYY');
          var time = dayjs_1.default(validTo()).format('HH:mm');
          validToString = "\u0437\u0430\u043A\u043E\u043D\u0447\u0438\u0442\u0441\u044F " + date + " \u0432 " + time;
          break;
        }

      case !declarative && 0 < restInMs && restInMs < dayInMs:
        {
          var oneHour = 60 * 60 * 1000;
          var oneMinute = 60 * 1000;
          var hours = Math.floor(restInMs / oneHour);
          var minutesInMs = restInMs % oneHour;
          var hoursString = hours > 0 ? hours + " " + common_1.getPluralForm(hours, ['час', 'часа', 'часов']) : '';
          var minutes = Math.floor(minutesInMs / oneMinute);
          var minutesString = minutes + " " + common_1.getPluralForm(minutes, [possessive ? 'минуту' : 'минута', 'минуты', 'минут']);
          validToString = [possessive ? 'закончится через' : 'осталось', hoursString, minutesString].filter(Boolean).join(' ');
          break;
        }

      case restInMs <= 0:
        {
          var date = dayjs_1.default(validTo()).format('D MMMM YYYY');
          validToString = "\u0437\u0430\u043A\u043E\u043D\u0447\u0438\u043B\u0441\u044F " + date;
          break;
        }

      default:
        {
          var date = dayjs_1.default(validTo()).format('D MMMM YYYY');
          validToString = "\u0434\u0435\u0439\u0441\u0442\u0432\u0443\u0435\u0442 \u0434\u043E " + date;
        }
    }

    return capital ? validToString.charAt(0).toUpperCase() + validToString.slice(1) : validToString;
  };

  return CertificateProcessor;
}();

exports.CertificateProcessor = CertificateProcessor;